const productConfigurationConstants = {
  PRODUCT_CONFIG_NEXT_STEP: "PRODUCT_CONFIG_NEXT_STEP",
  PRODUCT_CONFIG_GET_SELECTED: "PRODUCT_CONFIG_GET_SELECTED",
  PRODUCT_CONFIG_PREV_STEP: "PRODUCT_CONFIG_PREV_STEP",
  PRODUCT_CONFIG_SAVE_RECORD: "PRODUCT_CONFIG_SAVE_RECORD",
  PRODUCT_CONFIG_SET_SELECTED: "PRODUCT_CONFIG_SET_SELECTED",
  PRODUCT_CONFIG_SET_METAL: "PRODUCT_CONFIG_SET_METAL",
  PRODUCT_CONFIG_SET_DESIGN: "PRODUCT_CONFIG_SET_DESIGN",
  PRODUCT_CONFIG_SET_CUSTOM: "PRODUCT_CONFIG_SET_CUSTOM",
  PRODUCT_CONFIG_SET_MOTIF: "PRODUCT_CONFIG_SET_MOTIF",
  PRODUCT_CONFIG_RESET: "PRODUCT_CONFIG_RESET",
  PRODUCT_CONFIG_SET_THEME: "PRODUCT_CONFIG_SET_THEME",
  PRODUCT_CONFIG_SET_CONFIG_DATA: "PRODUCT_CONFIG_SET_CONFIG_DATA",
}

export default productConfigurationConstants
